import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "../Layout/Layout";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

const EmailDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const data = location.state;

  if (!data) {
    return (
      <main className="dashboard main" id="main">
        <Layout />
        <div className="p-4">
          <h4>No Email Found</h4>

          <button
            className="btn btn-primary mt-3"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>
      </main>
    );
  }

  return (
    <main className="dashboard main" id="main">
      <Layout />

      <Row className="subContent">
        <Col md={12}>
          <Card className="shadow-sm">

            <Card.Header className="d-flex justify-content-between align-items-center">

              <h4>Email Details</h4>

              <button
                className="btn btn-secondary"
                onClick={() => navigate(-1)}
              >
                Back
              </button>

            </Card.Header>

            <Card.Body>

              <Row className="mb-3">
                <Col md={2}>
                  <b>To</b>
                </Col>

                <Col md={10}>
                  {data.emailId}
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={2}>
                  <b>Vendor</b>
                </Col>

                <Col md={10}>
                  {data.vendorName}
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={2}>
                  <b>Subject</b>
                </Col>

                <Col md={10}>
                  {data.subject}
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={2}>
                  <b>Status</b>
                </Col>

                <Col md={10}>
                  <span className="badge bg-success">
                    {data.status}
                  </span>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={2}>
                  <b>Sent On</b>
                </Col>

                <Col md={10}>
                  {new Date(data.createdAt).toLocaleString()}
                </Col>
              </Row>

              <hr />

              <h5>Message</h5>

              <div
                className="border rounded p-3"
                dangerouslySetInnerHTML={{
                  __html: data.message,
                }}
              />

            </Card.Body>

          </Card>
        </Col>
      </Row>
    </main>
  );
};

export default EmailDetails;